export default function BrandLogo({ size = 'md', className = '' }) {
  const sizes = {
    sm: {
      text: 'text-xl',
    },
    md: {
      text: 'text-4xl',
    },
    lg: {
      text: 'text-5xl',
    },
  };

  const config = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center ${className}`}>
      <div className={`font-display ${config.text} font-black leading-none`}>
        <span className="text-white">Mec</span>
        <span className="text-orange-400">Sync</span>
      </div>
    </div>
  );
}
